<p-select
  [options]="statusList"
  [multiple]="true"
  [disabled]="disabled()"
  [ngModel]="selectedStatuses"
  (ngModelChange)="selectedStatuses = $event; onStatusChange()"
  [appendTo]="appendTo()"
  panelStyleClass="p-select-checkbox-options"
  placeholder="All statuses"
>
  <ng-template #item let-option>
    <p-checkbox
      [ngModel]="isSelected(option.value)"
      [binary]="true"
      [readonly]="true"
      [tabindex]="-1"
    />
    <span>{{ option.label }}</span>
  </ng-template>

  <ng-template #selectedItem>
    <app-selected-chips
      [items]="selectedStatuses"
      [label]="chipLabel"
      [removable]="!disabled()"
      (removeItem)="removeStatus($event)"
    />
  </ng-template>
</p-select>
